export const Result = ({ value, record }) => !record.result == null ? '' : (Math.round(record.result.result*100)/100).toFixed(2)
